'use strict';

module.exports = comment;

/* Stringify a comment `node`. */
function comment(ctx, node) {
  return '<!--' + node.value + '-->';
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-html/lib/comment.js
// module id = 991
// module chunks = 0